// src/data/productSliderData.js
// Ab sirf backend se data aata hai — koi static/hardcoded product ya image nahi.

const API_BASE = "https://aishcraft.com/backend/api";

export const categories = [
  "Dairy",
  "Photo book",
  "Albums",
  "Journal",
  "Notebook",
  "Notepad",
  "Table calander",
  "Travel book",
  "Corporate gift hampers",
  "Sketcbook"
];

export const PRODUCTS_PER_PAGE = 12;

// Product detail page ke liye — hamesha backend se fetch karta hai.
export async function getProductBySlug(slug) {
  try {
    const res = await fetch(`${API_BASE}/public/collection-product.php?id=${slug}`);
    const json = await res.json();
    return json.success ? json.data : null;
  } catch {
    return null;
  }
}

// Related products bhi backend se.
export async function getRelatedProducts(slug, count = 4) {
  try {
    const res = await fetch(`${API_BASE}/home/collections.php`);
    const json = await res.json();
    if (!json.success) return [];
    return (json.data || [])
      .filter((p) => String(p.id) !== String(slug))
      .slice(0, count)
      .map((p) => ({
        id: p.id,
        name: p.name,
        subtitle: p.subtitle || "",
        image: p.image_url,
        price: Number(p.new_price) || 0,
        comparePrice: p.old_price ? Number(p.old_price) : null,
      }));
  } catch {
    return [];
  }
}